import axios from '@/libs/axios'
import { ref } from '@vue/composition-api'

export function useWasherPlanApi() {

  const getPlans = async (params) => {
    return await axios.get('/plans', {params: params})
  }

  const save = async (formData) => {
    return await axios.post('/plans', formData)
  }

  const update = async (formData, id) => {
    return await axios.post(`/syncPlan/${id}`, formData)
  }

  const getPlan = async (id) => {
    return await axios.get(`/plans/${id}`)
  }

  return {
    save, update, getPlan, getPlans
  }

}